import React, { useState } from "react";
import { Tabs, Tab, Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import AllWarehouses from "./AllWarehouses";
import WareHouseDetails from "./WareHouseDetails";
import CreateWarehouse from "./CreateWarehouse"; 

const WareHouseTabs = () => {
  const [tabs, setTabs] = useState([{ label: "All Warehouses", component: "allWarehouses" },{ label: "Create Warehouses", component: "createWarehouse" }]);
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to Add a New Warehouse Tab
  const handleAddTab = (warehouse) => {
    const existingTab = tabs.find((tab) => tab.id === warehouse.option_id);
    if (!existingTab) {
      setTabs([...tabs, { id: warehouse.option_id, label: warehouse.title, component: "warehouseDetails", data: warehouse }]);
      setSelectedTab(tabs.length);
    } else {
      setSelectedTab(tabs.findIndex((tab) => tab.id === warehouse.option_id));
    }
  };

  // Function to Remove a Tab
  const handleCloseTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
    setTabs(newTabs);
    setSelectedTab(index === selectedTab ? Math.max(0, index - 1) : selectedTab);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* MUI Tabs */}
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{tab.label}</Typography>
                {index > 1 && (
                  <IconButton size="small" onClick={() => handleCloseTab(index)} sx={{ ml: 1 }}>
                    <Close fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ p: 2 }}>
        {tabs[selectedTab].component === "allWarehouses" && <AllWarehouses onWarehouseClick={handleAddTab} />}
        {tabs[selectedTab].component === "createWarehouse" && <CreateWarehouse />}
        {tabs[selectedTab].component === "warehouseDetails" && <WareHouseDetails warehouse={tabs[selectedTab].data} />}
      </Box>
    </Box>
  );
};

export default WareHouseTabs;
